import BroadcasterComponent from '@/components/BroadcastComponent';
import styles from './broadcaster.module.scss';

const Broadcaste = () => {
 
  return (
    <>
    <div className={styles.flowItem}>
        <div>
            <BroadcasterComponent />
        </div>
    </div>
    </>
  );
};

export default Broadcaste;
